import { useEffect, useMemo } from 'react';
import { AsyncDataHandler } from '@ds';
import classNames from 'classnames';
import { useUserProfileStore } from 'src/stores/UserProfile';
import { useGetUserContacts } from 'src/shared/queries/useGetUserContacts';
import { useGetUser } from 'src/shared/queries/useGetUser';
import { AddressType } from 'src/shared/types/User';
import PhoneContacts from './PhoneContacts/PhoneContacts';
import Emails from './Emails/Emails';
import Addresses from './Addresses/Addresses';
import { useScreenSize } from '@ds/utils/hooks/useScreenSize';

const ContactInformation = () => {
  const { editMode, profileInfo, setDisplayUpdateButton } = useUserProfileStore();
  const isPrincipal = profileInfo?.isPrincipal;
  const { isDesktop, isMobile } = useScreenSize();
  const { data: userProfile } = useGetUser();
  const userId = userProfile?.userId;
  const { data: userContacts, isFetching } = useGetUserContacts(isPrincipal ? userId : profileInfo?.id, isPrincipal);

  useEffect(() => {
    setDisplayUpdateButton(!isFetching && !!userContacts);
    return () => setDisplayUpdateButton(true);
  }, [userContacts, isFetching]);

  const contentToRender = useMemo(() => {
    if (!userContacts || isFetching) return null;

    const { contactRefId, contactPhones, contactEmails, contactAddresses } = userContacts;

    const addresses = contactAddresses?.filter((address) => address.addressType !== AddressType.WORK) || [];

    return (
      <div className="flex flex-col gap-[40px]">
        <PhoneContacts contactRefId={contactRefId} phones={contactPhones} />
        <Emails contactRefId={contactRefId} emails={contactEmails} />
        <Addresses contactRefId={contactRefId} addresses={addresses} />
      </div>
    );
  }, [userContacts, isFetching]);

  return (
    <div
      className={classNames({
        ['mt-[60px]']: !isFetching && isDesktop && !editMode,
        ['pt-[40px]']: !isFetching && isMobile,
      })}
    >
      <AsyncDataHandler isLoading={isFetching}>{contentToRender}</AsyncDataHandler>
    </div>
  );
};

export default ContactInformation;
